export default __webpack_public_path__ + "static/media/expoautosgroup.f9c6cdb4.jpeg";